import { lazyWithPreload as lazy } from 'react-lazy-with-preload';

const NewHome = {
  Content: lazy(
    () => import('components/direct-sales/new-home/components/NewHomeContent')
  ),
  Template: lazy(() => import('components/app/routes/NonRevampScreenTemplate'))
};

export default NewHome;
